<template>
  <div class="cgs-worksheet-cgsFormContent">
    <van-row align="center" style="height: 54px; line-height: 54px">
      <van-col span="16">
        <van-search v-model="searchValue" placeholder="请输入搜索关键词"></van-search>
      </van-col>
      <van-col span="4" style="text-align: center">
        <van-icon class-prefix="cgsIcon" name="filter-full" class="iconfont" @click="filtrationShow = true"/>
      </van-col>
      <van-col span="4">
        <van-icon class-prefix="cgsIcon" name="paixu" class="iconfont"/>
      </van-col>
    </van-row>
    <van-pull-refresh v-model="wholeLoading" @refresh="refresh" class="worksheet-cgsFormList">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="lazyLoad"
        v-if="worksheetList.length > 0">
        <van-checkbox-group v-model="delList" ref="checkboxGroup">
          <van-cell-group>
            <div @touchmove="touchMove" @touchstart="goTouchstart(item, index)" @touchend="touchEnd(item, index)"
              v-for="(item, index) in worksheetList" :key="index">
              <van-cell :title="getTitle(item, showDetailTitle)" :clickable="true" class="cgsFormList-row">
                <template #label>
                  <van-row :gutter="10" v-if="showDetailProps.length > 0">
                    <van-col :span="24 / showDetailProps.length" v-for="prop in showDetailProps" :key="prop.id">
                      <div>
                        <div class="ellipsis">{{ prop.alia }}</div>
                        <div v-if="prop.dataType === 42">
                          <img :src="item[prop.name]" alt="签名" style="height: 30px"
                            v-if="item[prop.name] && item[prop.name] !== ''" />
                        </div>
                        <div v-else-if="prop.dataType === 11">
                          <span v-if="item[prop.name] && item[prop.name].length > 0" class="text-overflow"
                            style="width: 100px;">
                            {{ item[prop.name].map((_t) => _t.label).join(",") }}
                          </span>
                        </div>
                        <div v-else class="ellipsis form-value-show">
                          {{ getFieldDataName(item[prop.name]) }}
                        </div>
                      </div>
                    </van-col>
                  </van-row>
                </template>
                <template #right-icon>
                  <van-checkbox :name="item" ref="checkboxes" v-show="checkboxesDelShow"
                    :disabled="delRowDisabled(item)" />
                </template>
              </van-cell>
            </div>
          </van-cell-group>
        </van-checkbox-group>
      </van-list>

      <van-empty description="暂无记录" v-if="worksheetList.length === 0" />
    </van-pull-refresh>
    <div class="suspensionTool createRow" :class="addRowAuth === 1 ? '' : 'createRowButtonDisable'" @click="createRow">
      <van-icon class-prefix="cgsIcon" name="xinzeng" class="iconfont" />
      <span style="font-size: 14px">记录</span>
    </div>

    <div v-show="checkboxesDelShow" class="checkboxes-del-show">
      <div v-if="checkboxAllShow" class="checkboxes-del-show-left"
        :class="delRowAuth < 2 ? 'selectAllButtonDisabled' : ''" @click="checkboxAll">全选</div>
      <div v-else class="checkboxes-del-show-left" @click="checkboxAll">取消全选</div>
      <div class="checkboxes-del-show-center" @click="secedeCheckboxesDelShow">退出</div>
      <div class="checkboxes-del-show-right" @click="delBatchList">删除</div>
    </div>


    <van-popup v-model="filtrationShow" position="right" :style="{ height: '100%',width: '80%' }">
      <van-cell title="筛选"/>
      <van-cell title="自定义筛选" style="color:#1995fc;" @click="filtrationDialogShow = true">
        <template #right-icon v-if="filters && filters.length > 0">
          <van-icon name="success" />
        </template>
      </van-cell>
      <div class="filtrationShow-footer">
        <div @click="filters = [] , filtrationShow = false" class="filtrationShow-reset">重置</div>
        <div @click="updateFilters" class="filtrationShow-yes">确定</div>
      </div>
    </van-popup>

    <van-popup v-model="filtrationDialogShow" position="bottom" style="height:100%;background:#f4f4f4" :overlay="true" duration="0">
      <van-nav-bar :border="true">
        <template #left>
            <span class="iconfont cgsIcon-houtui" @click="filtrationDialogShow = false , filters = []"></span>
            <span style="margin-left:20px;font-weight:bold">自定义筛选</span>
        </template>
        <template #right>
            <van-icon name="success" color="#000000" size="30" @click="filtrationDialogShow = false"/>
        </template>
      </van-nav-bar>
      <div v-if="filters && filters.length === 0" @click="addFiltrationShow = true">
        <van-empty description="暂无筛选条件，点击添加"/>
      </div>
      <div v-else style="overflow-x:hidden">
        <div v-for="(item,index) in filters" :key="index">
          <div class="filtrationDialog-cell">
            <div style="display: flex;justify-content:space-between">
              <div>
                <span style="margin-left:10px">{{item.alia}}</span>
                <span style="margin-left:20px;border-bottom: 1px solid #c8c9cc;" @click="updataFiltrationCondition(index)">{{item.filterAlia}}</span>
              </div>
              <div style="margin-right:10px">
                <van-icon name="cross" class="filtrationDialog-cell-X" @click="delFiltrationCondition(index)"/>
              </div>
            </div>
            <div v-if="item.dateRange" style="margin:10px;">
              <div v-if="item.dataType === dataType.DATE && (item.dateRange === dateRange.PAST_SEVERAL_DAYS || item.dateRange === dateRange.FEATURE_SEVERAL_DAYS)">
                <div style="display: flex;justify-content: space-between;">
                  <span style="border-bottom: 1px solid #c8c9cc;" @click="updataFiltrationClick(index)">{{item.dateAlia}}</span>
                  <span style="border-bottom: 1px solid #c8c9cc;margin-right:10px;width:40%;" @click="updataFiltrationDateClick(index)">{{item.value}}</span>
                </div>
                <div style="display:flex;justify-content: space-between;align-items:center;margin-top:10px">
                  <span>包含今天</span>
                  <van-switch v-model="item.dateValueschecked" inactive-color="#dcdee0" size="24px" @change="updataDateSwitch(item)" style="margin-right:10px"/>
                </div>
              </div>
              <div v-else>
                <span style="border-bottom: 1px solid #c8c9cc;" @click="updataFiltrationClick(index)">{{item.dateAlia}}</span>
              </div>
            </div>
            <div v-else style="padding: 10px;display: flex;flex-wrap:wrap">
              <div v-for="(value,index) in item.values" :key="index" style="display: flex;flex-wrap:wrap">
                <div class="filtrationDialog-cell-values">
                  <span style="margin:0px 5px">{{value}}</span>
                  <van-icon style="margin:0px 5px" name="cross" @click="delFiltrationClick(item.values,index)"/>
                </div>
              </div>
              <div v-if="item.values && item.values.length > 0">
                <van-icon name="plus" class="filtrationDialog-cell-values-jia"  @click="updataFiltrationClick(index)"/>
              </div>
              <div v-else class="filtrationDialog-cell-values-tian"  @click="updataFiltrationClick(index)">
                <van-icon name="plus"/>
                <span style="margin-left:5px">添加筛选值</span>
              </div>
            </div>
          </div>
          <div class="filtrationDialog-cell-spliceType">
            <el-switch
              v-model="item.spliceType"
              active-text="或"
              inactive-text="且"
              :active-value= 1
              :inactive-value= 0 
              @change="updataFiltrationSpliceTypeClick">
            </el-switch>
          </div>
        </div>
        <van-cell style="margin-top:10px" @click="addFiltrationShow = true">
          <template #title>
            <van-icon name="plus" color='#1d94f2' size='20' style="font-weight:bold"/>
            <span style="margin-left:20px;font-weight:bold">添加筛选条件</span>
          </template>
        </van-cell>
      </div>
    </van-popup>

    <van-popup v-model="addFiltrationShow" position="bottom" :style="{ height: '60%'}" round>
      <van-cell title="选择字段"/>
      <van-cell v-for="item in filterList" :key="item.name" :title="item.alia" @click="selectFieldChange(item)"/>
    </van-popup>

    <van-popup v-model="addFiltrationConditionShow" position="bottom" :style="{ height: '60%'}" round @click-overlay="aheadOfSchedule">
      <van-nav-bar :border="true">
        <template #left>
            <span v-if="updataFiltration === false" class="iconfont cgsIcon-houtui" @click="addFiltrationConditionShow = false,addFiltrationShow = true"></span>
            <span style="margin-left:20px;font-weight:bold">选择筛选规则</span>
        </template>
        <template #right>
            <span style="font-weight:bold" @click="aheadOfSchedule">完成</span>
        </template>
      </van-nav-bar>
      <div v-if="filter.dataType === dataType.TEXT || filter.dataType === dataType.TEXT_AREA || filter.dataType === dataType.RADIO || filter.dataType === dataType.SELECT || filter.dataType === dataType.MEMBER || filter.dataType === dataType.PERSONNEL">
        <van-cell v-for="item in textOption" :key="item.value" :title="item.alia" @click="addFiltrationCondition(item)"></van-cell>
      </div>
      <div v-if="filter.dataType === dataType.NUMBER">
        <van-cell v-for="item in numberOption" :key="item.value" :title="item.alia" @click="addFiltrationCondition(item)"></van-cell>
      </div>
      <div v-if="filter.dataType === dataType.DATE">
        <van-cell v-for="item in dateOption" :key="item.value" :title="item.alia" @click="addFiltrationCondition(item)"></van-cell>
      </div>
    </van-popup>

    <van-popup v-model="addFiltrationCondition1Show" position="bottom" :style="{ height: '60%'}" round @click-overlay="addFiltration(false)">
      <van-nav-bar :border="true">
        <template #left>
            <span v-if="updataFiltration === false" class="iconfont cgsIcon-houtui" @click="addFiltrationCondition1Show = false,addFiltrationConditionShow = true"></span>
            <span style="margin-left:20px;font-weight:bold">输入筛选值</span>
        </template>
        <template #right>
            <span style="font-weight:bold" @click="addFiltration(false)">完成</span>
        </template>
      </van-nav-bar>
      <div v-if="filter.dataType === dataType.DATE">
        <van-cell v-for="item in dateDetailOption" :key="item.value" :title="item.alia" @click="addFiltration(item)"></van-cell>
      </div>
      <div v-else style="border-bottom:3px solid #1a6cb2;width: 90%;margin-left:5%;">
        <input style="border-style: none;height:30px;" v-model="values">
      </div>
    </van-popup>

    <van-popup v-model="addFiltrationCondition2Show" position="bottom" :style="{ height: '60%'}" round @click-overlay="addFiltrationDateValues()">
      <van-nav-bar :border="true">
        <template #left>
            <span style="margin-left:20px;font-weight:bold">输入筛选值</span>
        </template>
        <template #right>
            <span style="font-weight:bold" @click="addFiltrationDateValues()">完成</span>
        </template>
      </van-nav-bar>
      <div style="border-bottom:3px solid #1a6cb2;width: 90%;margin-left:5%;">
        <input style="border-style: none;height:30px;" type="number" v-model="values">
      </div>
    </van-popup>
  </div>
</template>

<script>
  import {
    NavBar,
    Tab,
    Tabs,
    PullRefresh,
    Search,
    List,
    Col,
    Row,
    Icon,
    Cell,
    CellGroup,
    Empty,
    ImagePreview,
    SwipeCell,
    Button,
    Checkbox,
    CheckboxGroup,
    ActionSheet,
    Popup,
    Switch,
  } from "vant";
  import {
    getAppAuth,
    getFilterDataList,
    delRow,
    delRowBatch,
  } from "@/api/application";
  import {
    getUserAuthority
  } from "@/util/author";
  import {DataType, FilterType, DateRange} from '../../filterConstant'

  export default {
    components: {
      vanNavBar: NavBar,
      vanTab: Tab,
      vanTabs: Tabs,
      vanSearch: Search,
      vanList: List,
      vanPullRefresh: PullRefresh,
      vanCol: Col,
      vanRow: Row,
      vanIcon: Icon,
      vanCell: Cell,
      vanCellGroup: CellGroup,
      vanEmpty: Empty,
      vanSwipeCell: SwipeCell,
      vanButton: Button,
      vanCheckbox: Checkbox,
      vanCheckboxGroup: CheckboxGroup,
      vanActionSheet: ActionSheet,
      vanPopup: Popup,
      vanSwitch: Switch,
    },
    props: {
      worksheetDetail: {
        type: Object,
        default: () => {
          return {}
        }
      },
      viewId: {
        type: String,
        default: ''
      },
      hiddenFields: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        searchValue: "",
        wholeLoading: false,
        worksheetList: [],
        searchHandler: null,
        loading: false,
        finished: true,
        currentPageNumber: 0,
        allPageNumber: 1,
        pageSize: 15,
        // showOtherUserRow: false,
        // rowAddable: false,
        showRowAuth: 0,
        addRowAuth: 0,
        delRowAuth: 0,

        delList: [],
        timeOutEvent: null,
        checkboxesDelShow: false,
        checkboxAllShow: true,
        isAll: false,
        isPull: false,
        // isGotouchmove: false,
        filtrationShow: false,
        filtrationDialogShow: false,
        addFiltrationShow: false,
        updataFiltration: false,
        updataFiltrationIndex: 0,
        addFiltrationConditionShow: false,
        addFiltrationCondition1Show: false,
        addFiltrationCondition2Show: false,
        filter:{},
        filters:[],
        values:'',


        dataType: DataType,
        dateRange: DateRange,
        filterDataType:[0,1,5,8,10,11,14,63],
        textOption: [
          {
            value: FilterType.INCLUDE,
            alia: '包含'
          },
          {
            value: FilterType.EQUAL,
            alia: '是'
          },
          {
            value: FilterType.BEGAIN,
            alia: '开头为'
          },
          {
            value: FilterType.END,
            alia: '结尾为'
          },
          {
            value: FilterType.EXCLUSIVE,
            alia: '不包含'
          },
          {
            value: FilterType.UNEQUAL,
            alia: '不是'
          }
        ],
        numberOption: [
          {
            value: FilterType.EQUAL,
            alia: '='
          },
          {
            value: FilterType.UNEQUAL,
            alia: '≠'
          },
          {
            value: FilterType.GREATER,
            alia: '>'
          },
          {
            value: FilterType.GREATER_EQUAL,
            alia: '>='
          },
          {
            value: FilterType.LESS,
            alia: '<'
          },
          {
            value: FilterType.LESS_EQUAL,
            alia: '<='
          }
        ],
        dateOption: [
          {
            value: FilterType.DATE_YES,
            alia: '日期是'
          },
          {
            value: FilterType.DATE_NO,
            alia: '日期不是'
          }
        ],
        dateDetailOption: [
          {
            value: DateRange.TODAY,
            alia: '今天'
          },
          {
            value: DateRange.YESTERDAY,
            alia: '昨天'
          },
          {
            value: DateRange.TOMORROW,
            alia: '明天'
          },
          {
            value: DateRange.THIS_WEEK,
            alia: '本周'
          },
          {
            value: DateRange.LAST_WEEK,
            alia: '上周'
          },
          {
            value: DateRange.NEXT_WEEK,
            alia: '下周'
          },
          {
            value: DateRange.THIS_MONTH,
            alia: '本月'
          },
          {
            value: DateRange.LAST_MONTH,
            alia: '上月'
          },
          {
            value: DateRange.NEXT_MONTH,
            alia: '下月'
          },
          {
            value: DateRange.PAST_SEVERAL_DAYS,
            alia: '过去...天'
          },
          {
            value: DateRange.FEATURE_SEVERAL_DAYS,
            alia: '将来...天'
          }
        ],
      };
    },
    async mounted() {
      await this.load();
    },
    computed: {
      userId: {
        get() {
          let userAuthority = getUserAuthority();
          return userAuthority.userId;
        },
        set() {},
      },
      worksheetId: {
        get() {
          return this.$props.worksheetDetail.id;
        },
        set() {},
      },
      appId: {
        get() {
          return this.$props.worksheetDetail.appId;
        },
        set() {},
      },
      showWorksheetList: {
        get() {
          if (this.showRowAuth === 2) {
            return this.worksheetList;
          } else if (this.showRowAuth === 1) {
            return this.worksheetList.filter(
              (item) => item.owner === this.userId
            );
          } else {
            return []
          }
        },
        set() {},
      },
      showDetailTitle: {
        get() {
          let _obj = '';
          if (this.$props.worksheetDetail.fields) {
            let fields = this.$props.worksheetDetail.fields
            if (fields.length > 0) {
              if (this.hiddenFields !== null && this.hiddenFields.length > 0) {
                _obj = fields.find(_item => !this.hiddenFields.includes(_item.name))
              } else {
                _obj = fields[0]
              }
            }
          }
          return _obj
        },
        set() {},
      },
      showDetailProps: {
        get() {
          let _list = [];
          let _isF = true //判断是不是第一个
          if (this.$props.worksheetDetail.fields) {
            let fields = this.$props.worksheetDetail.fields
            if (fields.length > 0) {
              if (this.hiddenFields !== null && this.hiddenFields.length > 0) {
                for (let i = 0; i < fields.length; i++) {
                  let _item = fields[i]
                  if (!this.hiddenFields.includes(_item.name)) {
                    if (_isF) {
                      _isF = false
                    } else {
                      if (_list.length < 3) {
                        _list.push(_item)
                      } else {
                        break
                      }
                    }
                  }
                }
                return _list
              } else {
                _list = fields.filter((_item, index) => {
                  return index > 0 && index < 4
                })
              }
            }
          }
          return _list;
        },
        set() {},
      },
      filterList: {
        get() {
          let list = []
          this.$props.worksheetDetail.fields.forEach((item)=>{
            this.filterDataType.forEach((typeItem)=>{
              if(item.dataType === typeItem){
                list.push(item)
              }
            })
          })
          return list
        },
        ser() {},
      },
    },
    watch: {
      worksheetDetail() {
        this.refresh();
      },
      searchValue() {
        if (this.searchHandler === null) {
          this.searchHandler = setTimeout(() => {
            this.refresh();
            this.searchHandler = null;
          }, 1000);
        } else {
          clearTimeout(this.searchHandler);
          this.searchHandler = setTimeout(() => {
            this.refresh();
            this.searchHandler = null;
          }, 1000);
        }
      },
      filtrationShow(){
        if(this.filtrationShow === true){
          window.__StopGlobleBackButton = true
        }else{
          window.__StopGlobleBackButton = false
        }
      },
    },
    // created () {
    //   this.filtersDataEcho()
    // },
    methods: {
      // 筛选数据回显
      // filtersDataEcho(){
      //   let arr = []
      //   this.worksheetDetail.viewList.forEach((item)=>{
      //     if(item.id === this.viewId){
      //       item.filters.forEach((i)=>{
      //         arr = arr.concat(i)
      //       })
      //       this.filters = arr
      //     }
      //   })
      //   this.filters.forEach((item)=>{
      //     if(item.dataType === this.dataType.TEXT || item.dataType === this.dataType.TEXT_AREA || item.dataType === this.dataType.RADIO || item.dataType === this.dataType.SELECT || item.dataType === this.dataType.MEMBER || item.dataType === this.dataType.PERSONNEL){
      //       this.textOption.forEach((typeItem)=>{
      //         if(typeItem.value === item.filterType){
      //           item.filterAlia = typeItem.alia
      //         }
      //       })
      //     }
      //     if(item.dataType === this.dataType.NUMBER){
      //       this.numberOption.forEach((typeItem)=>{
      //         if(typeItem.value === item.filterType){
      //           item.filterAlia = typeItem.alia
      //         }
      //       })
      //     }
      //     if(item.dataType === this.dataType.DATE){
      //       this.dateOption.forEach((typeItem)=>{
      //         if(typeItem.value === item.filterType){
      //           item.filterAlia = typeItem.alia
      //         }
      //       })
      //       this.dateDetailOption.forEach((dateDetailItem)=>{
      //         if(item.dateRange === dateDetailItem.value){
      //           item.dateAlia = dateDetailItem.alia
      //         }
      //       })
      //       if(item.values && item.values.length > 0){
      //         item.values.forEach((valuesItem)=>{
      //           if(valuesItem === "today"){
      //             item.dateValueschecked = true
      //           }else{
      //             item.dateValueschecked = false
      //           }
      //         })
      //       }
      //     }
      //     this.worksheetDetail.fields.forEach((aliaItem)=>{
      //       if(item.field === aliaItem.name){
      //         item.alia = aliaItem.alia
      //       }
      //     })
      //   })
      // },
      // 筛选条件提交
      async updateFilters(){
        let arr = []
        this.filters.forEach((item)=>{
          if(item.dateRange){
            let obj = (({dataType, dateRange,field,filterType,spliceType,value,values}) =>({dataType,dateRange,field,filterType,spliceType,value,values}))(item);
            arr.push(obj)
          }else{
            let obj = (({dataType,field,filterType,spliceType,value,values}) =>({dataType,field,filterType,spliceType,value,values}))(item);
            arr.push(obj)
          }
        })
        // let array = []
        // let j = 0
        // array[j] = []
        // for (let i = 0; i < arr.length; i++) {
        //   array[j].push(arr[i])
        //   if(arr[i].spliceType === 1){
        //     j++
        //     array[j] = []
        //   }
        // }
        let params = {
          filters: arr,
          isAsc: null,
          pageNo: this.currentPageNumber,
          pageSize: this.pageSize,
          sortField: "updateTime",
          worksheetId: this.worksheetId,
          worksheetViewId: this.viewId
        };
        let result = await getFilterDataList(params)
        if (result.code === 200) {
          this.$Notify({
            type: "success",
            message: "设置成功"
          });
          this.filtrationShow = false
          this.refresh()
        } else {
          this.$Notify({
            type: "danger",
            message: result.msg
          });
        }
      },
      updataFiltrationSpliceTypeClick(){
        this.$forceUpdate()
      },
      updataDateSwitch(item){
        if(item.dateValueschecked === true){
          item.values = ["today"]
        }else{
          item.values = []
        }
        this.$forceUpdate()
      },
      delFiltrationCondition(index){
        this.filters.splice(index,1)
      },
      delFiltrationClick(value,index){
        value.splice(index,1)
        this.$forceUpdate()
      },
      updataFiltrationCondition(index){
        this.filter = this.filters[index]
        this.values = ''
        this.updataFiltrationIndex = index
        this.updataFiltration = true
        this.addFiltrationConditionShow = true
      },
      updataFiltrationClick(index){
        this.filter = this.filters[index]
        this.values = ''
        this.updataFiltrationIndex = index
        this.updataFiltration = true
        this.addFiltrationCondition1Show = true
      },
      updataFiltrationDateClick(index){
        this.filter = this.filters[index]
        this.values = ''
        this.updataFiltrationIndex = index
        this.updataFiltration = true
        this.addFiltrationCondition2Show = true
      },
      addFiltrationDateValues(){
        if(this.updataFiltration){
          if(this.values !== ''){
            this.filters[this.updataFiltrationIndex].value = this.values
          }
        }else{
          if(this.values !== ''){
            this.filter.value = this.values
          }
          this.filters.push(this.filter)
        }
        this.addFiltrationCondition2Show = false
      },
      aheadOfSchedule(){
        if(this.updataFiltration === false){
          if(this.filter.dataType === this.dataType.TEXT || this.filter.dataType === this.dataType.TEXT_AREA || this.filter.dataType === this.dataType.RADIO || this.filter.dataType === this.dataType.SELECT || this.filter.dataType === this.dataType.MEMBER || this.filter.dataType === this.dataType.PERSONNEL){
            this.filter.filterType = 1
            this.filter.filterAlia = '包含'
          }else if(this.filter.dataType === this.dataType.NUMBER){
            this.filter.filterType = 2
            this.filter.filterAlia = '='
          }else if(this.filter.dataType === this.dataType.DATE){
            this.filter.filterType = 16
            this.filter.filterAlia = '日期是'
          }
          this.filters.push(this.filter)
        }
      },
      addFiltration(item){
        if(item === false){
          if(this.updataFiltration){
            if(this.values !== ''){
              this.filters[this.updataFiltrationIndex].values.push(this.values)
            }
          }else{
            this.filter.values = []
            if(this.values !== ''){
              this.filter.values.push(this.values)
            }
            this.filters.push(this.filter)
          }
        }else{
          if(this.updataFiltration){
            this.filters[this.updataFiltrationIndex].dateRange = item.value
            this.filters[this.updataFiltrationIndex].dateAlia = item.alia
            if(this.filter.dataType === this.dataType.DATE && (this.filter.dateRange === this.dateRange.PAST_SEVERAL_DAYS || this.filter.dateRange === this.dateRange.FEATURE_SEVERAL_DAYS)){
              this.filter.dateValueschecked = false
              this.filter.values = []
              this.addFiltrationCondition2Show = true
            }else{
              this.filters[this.updataFiltrationIndex].value = ''
            }
          }else{
            this.filter.dateRange = item.value
            this.filter.dateAlia = item.alia
            if(this.filter.dataType === this.dataType.DATE && (this.filter.dateRange === this.dateRange.PAST_SEVERAL_DAYS || this.filter.dateRange === this.dateRange.FEATURE_SEVERAL_DAYS)){
              this.filter.dateValueschecked = false
              this.filter.values = []
              this.addFiltrationCondition2Show = true
            }else{
              this.filters.push(this.filter)
            }
          }
        }
        this.addFiltrationCondition1Show = false
      },
      addFiltrationCondition(item){
        if(this.updataFiltration){
          this.filters[this.updataFiltrationIndex].filterAlia = item.alia
          this.filters[this.updataFiltrationIndex].filterType = item.value
        }else{
          this.filter.filterAlia = item.alia
          this.filter.filterType = item.value
        }
        this.addFiltrationConditionShow = false
        this.addFiltrationCondition1Show = true
      },
      selectFieldChange(item){
        this.values = ''
        this.filter = {}
        this.updataFiltration = false
        this.filter.dataType = item.dataType
        this.filter.field = item.name
        this.filter.alia = item.alia
        this.filter.spliceType = 0
        this.addFiltrationConditionShow = true
        this.addFiltrationShow = false
      },
      delRowDisabled(row) {
        let _disabled = true
        if (this.delRowAuth === 2) {
          _disabled = false
        } else if (this.delRowAuth === 1) {
          if (row.owner === this.userId) {
            _disabled = false
          }
        }
        return _disabled
      },
      getTitle(item, showDetailTitle) {
        let title = "";
        if (item) {
          if (showDetailTitle.dataType === 11) {
            if (
              item[showDetailTitle.name] &&
              item[showDetailTitle.name].length > 0
            ) {
              title = item[showDetailTitle.name]
                .map((_item) => _item.label)
                .join(",");
            }
          } else {
            title =
              typeof item[showDetailTitle.name] === "object" ?
              item[showDetailTitle.name] === null ?
              null :
              item[showDetailTitle.name].label :
              item[showDetailTitle.name];
          }
        }
        return title;
      },
      getFieldDataName(fieldData) {
        let value = "";
        if (fieldData instanceof Array) {
          fieldData.forEach((item) => {
            value += "/" + this.getFieldDataName(item);
          });
        } else if (fieldData instanceof Object) {
          value = fieldData.name ?
            fieldData.name :
            fieldData.label === "" ?
            fieldData.address :
            fieldData.label;
        } else {
          value = fieldData;
        }
        return value;
      },
      load() {
        if (
          this.worksheetId === "" ||
          this.worksheetId === null ||
          this.worksheetId === undefined
        )
          return;
        this.currentPageNumber++;
        return new Promise(async (resolve, reject) => {
          try {
            let arr = []
            this.filters.forEach((item)=>{
              if(item.dateRange){
                let obj = (({dataType, dateRange,field,filterType,spliceType,value,values}) =>({dataType,dateRange,field,filterType,spliceType,value,values}))(item);
                arr.push(obj)
              }else{
                let obj = (({dataType,field,filterType,spliceType,value,values}) =>({dataType,field,filterType,spliceType,value,values}))(item);
                arr.push(obj)
              }
            })
            let params = {
              filters: arr,
              isAsc: false,
              pageNo: this.currentPageNumber,
              pageSize: this.pageSize,
              sortField: "updateTime",
              keywords: this.searchValue,
              worksheetId: this.worksheetId,
              worksheetViewId: this.viewId
            };
            if (this.appId) {
              let appAuthResult = await getAppAuth(this.appId);
              let appAuth = appAuthResult.data;
              this.setRowAuth(appAuth);
            }

            let result = await getFilterDataList(params);
            this.allPageNumber = result.totalPage;
            this.worksheetList = this.worksheetList.concat(result.data);
            this.loading = false;
            if (this.currentPageNumber === this.allPageNumber) {
              this.finished = true;
            } else {
              this.finished = false;
            }
            resolve(true);
          } catch (e) {
            resolve(false);
          }
        });
      },
      async refresh() {
        this.wholeLoading = true;
        this.worksheetList = [];
        this.loading = false;
        this.finished = true;
        this.currentPageNumber = 0;
        this.allPageNumber = 1;
        this.isPull = false
        await this.load();

        this.wholeLoading = false;
      },
      goBack() {
        this.$router.go(-1);
      },
      touchMove() {
        this.clearLongPressTime()
        this.isPull = true
      },
      clearLongPressTime() {
        if (this.timeOutEvent !== null) {
          clearTimeout(this.timeOutEvent);
          this.timeOutEvent = null
        }
      },
      goTouchstart(row, index) {
        let _this = this;
        this.isPull = false
        this.clearLongPressTime()
        if (this.checkboxesDelShow) {
          if (!_this.delRowDisabled(row)) {
            _this.$refs.checkboxes[index].toggle();
          } else {
            this.$Notify({
              type: "danger",
              message: "没有删除该记录的权限"
            });
          }

        }
        _this.timeOutEvent = setTimeout(function () {
          _this.timeOutEvent = null;
          //  处理长按事件...
          if (_this.checkboxesDelShow === false) {
            _this.checkboxesDelShow = true
            if (!_this.delRowDisabled(row)) {
              _this.$refs.checkboxes[index].toggle();
            } else {
              this.$Notify({
                type: "danger",
                message: "没有删除该记录的权限"
              });
            }

          }
        }, 600);
      },
      touchEnd(row, index) {
        this.clearLongPressTime()
        if (this.isPull) return
        if (!this.checkboxesDelShow) {
          this.$router.push({
            path: `/updateRow/${this.worksheetId}/${row.rowId}`,
          });
        }
      },
      // 退出
      secedeCheckboxesDelShow() {
        this.checkboxesDelShow = false
        this.$refs.checkboxGroup.toggleAll(false)
      },
      createRow() {
        if (this.addRowAuth === 0) return;
        this.$router.push({
          path: `/createRow/${this.worksheetId}`
        });
      },
      async lazyLoad() {
        await this.load();
      },
      setRowAuth(appAuthObj) {
        //注意赋值顺序
        let appAuth = appAuthObj['appAuth']
        if (appAuth.includes("MANAGE_APP_AUTH")) {
          this.delRowAuth = 2
          this.showRowAuth = 2;
          this.addRowAuth = 1;
          return;
        }
        if (appAuthObj['formAuth'] === null) {
          if (appAuth.includes("EDIT_FORM")) {
            this.delRowAuth = 2
            this.showRowAuth = 2;
            this.addRowAuth = 1;
            return;
          }
          if (appAuth.includes("EDIT_FORM2")) {
            this.delRowAuth = 1
            this.showRowAuth = 2;
            this.addRowAuth = 1;
            return;
          }
          if (appAuth.includes("EDIT_FORM3")) {
            this.delRowAuth = 1
            this.showRowAuth = 1;
            this.addRowAuth = 1;
            return;
          }

          if (appAuth.includes("EDIT_FORM4")) {
            this.delRowAuth = 0
            this.showRowAuth = 2;
            this.addRowAuth = 0;
            return;
          }
        } else {
          let formAuthMap = appAuthObj['formAuth']
          let formAuth = formAuthMap[this.worksheetId]
          if (formAuth.includes("ROW_ADD")) {
            this.addRowAuth = 1
          }
          if (formAuth.includes("ROW_READ_OWN")) {
            this.showRowAuth = 1
          }
          if (formAuth.includes("ROW_READ_ALL")) {
            this.showRowAuth = 2
          }
          if (formAuth.includes("ROW_DELETE_OWN")) {
            this.delRowAuth = 1
          }
          if (formAuth.includes("ROW_DELETE_ALL")) {
            this.delRowAuth = 2
          }
        }

      },
      checkboxAll() {
        if (this.delRowAuth < 2) {
          this.$Notify({
            type: "danger",
            message: "没有全选记录的权限"
          });
          return;
        }
        if (this.checkboxAllShow == true) {
          this.$refs.checkboxGroup.toggleAll(true);
          this.checkboxAllShow = false
          this.isAll = true
        } else {
          this.$refs.checkboxGroup.toggleAll(false);
          this.checkboxAllShow = true
          this.isAll = false
        }
      },
      // async delOneList(e) {
      //   let rowId = e.rowId
      //   let worksheetId = e.worksheetId
      //   let result = await delRow(rowId, worksheetId);
      //   if (result.code === 200) {
      //     this.$Notify({
      //       type: "success",
      //       message: "删除成功"
      //     });
      //     // this.refresh();
      //     this.emitDelRows([rowId])
      //     this.checkboxesDelShow = false
      //   } else {
      //     this.$Notify({
      //       type: "danger",
      //       message: result.msg
      //     });
      //   }
      // },
      async delBatchList() {
        let rowIds = []
        this.delList.forEach((item) => {
          rowIds.push(item.rowId)
        })
        let params = {
          rowIds: rowIds,
          worksheetId: this.delList[0].worksheetId,
          isAll: this.isAll
        }
        let result = await delRowBatch(params);
        if (result.code === 200) {
          this.$Notify({
            type: "success",
            message: "删除成功"
          });
          // this.refresh();
          this.emitDelRows(rowIds)
          this.checkboxesDelShow = false
        } else {
          this.$Notify({
            type: "danger",
            message: result.msg
          });
        }
      },
      emitDelRows(ids) {
        this.$emit('deleteRowIds', ids)
      },
      delWorksheetRows(ids) {
        this.worksheetList = this.worksheetList.filter((item) => {
          return !ids.includes(item.rowId)
        })
      }
    },
  };
</script>

<style scoped>
  .text-overflow {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
  }

  .cgs-worksheet-cgsFormContent {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .cgs-worksheet-cgsFormContent .worksheet-cgsFormList {
    flex-grow: 1;
    padding: 10px;
  }

  .form-value-show {
    color: #323233;
  }

  .cgsFormList-row {
    border-radius: 3px;
    box-shadow: 0 0 10px -5px;
    margin-bottom: 10px;
  }

  .cgs-worksheet-cgsFormContent .suspensionTool {
    position: absolute;
  }

  .cgs-worksheet-cgsFormContent .createRow {
    height: 30px;
    line-height: 30px;
    width: 80px;
    right: 20px;
    bottom: 15px;
    border-radius: 20px;
    background: rgba(33, 150, 243, 1);
    text-align: center;
    color: #fff;
  }

  .createRowButtonDisable {
    cursor: not-allowed;
    opacity: 0.5;
  }

  @keyframes example {
    0% {
      bottom: -45px
    }

    25% {
      bottom: -30px
    }

    50% {
      bottom: -15px
    }

    100% {
      bottom: 0px
    }
  }

  .checkboxes-del-show {
    width: 100%;
    height: 45px;
    border-radius: 10px 10px 0px 0px;
    text-align: center;
    position: absolute;
    bottom: 0px;
    /* background: rgb(179, 183, 186); */
    z-index: 100;
    display: flex;
    justify-content: space-between;
    animation-name: example;
    animation-duration: 0.1s;
  }

  .checkboxes-del-show-left {
    width: 34%;
    height: 45px;
    line-height: 45px;
    border-radius: 10px 0px 0px 0px;
    background: rgb(123, 227, 149);
    color: #fff;
  }

  .checkboxes-del-show-center {
    width: 32%;
    height: 45px;
    line-height: 45px;
    background: rgb(90, 158, 232);
    color: #fff;
  }

  .checkboxes-del-show-right {
    width: 34%;
    height: 45px;
    line-height: 45px;
    border-radius: 0px 10px 0px 0px;
    background: rgb(232, 107, 90);
    color: #fff;
  }

  .selectAllButtonDisabled {
    background: #c8c9cc;
  }
  .filtrationDialog-cell{
    margin-right: 10px;
    padding: 10px;
    background: #fff;
    width: 100%;
    margin-top: 5px;
  }
  .filtrationDialog-cell-X{
    background: #c8c9cc;
    border-radius: 50%;
    margin-right: 10px;
    padding: 3px;
    color: #fff;
  }
  .filtrationDialog-cell-values{
    padding: 3px;
    margin-right: 5px;
    background: #f4f4f4;
    border-radius: 12.2px;
  }
  .filtrationDialog-cell-values-jia{
    padding: 3px;
    margin-left: 10px;
    background: #f4f4f4;
    border-radius: 12.2px;
  }
  .filtrationDialog-cell-values-tian{
    padding: 3px;
    display: flex;
    align-items: center;
    border: 1px solid #c8c9cc;
    border-radius: 12.2px;
  }
  .filtrationDialog-cell-spliceType{
    text-align: center;
    margin-top: 10px;
  }
  .filtrationShow-footer{
    display:flex;justify-content: center;position: fixed;bottom: 0px;width: 100%;
  }
  .filtrationShow-reset{
    width: 50%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border: 1px solid #ebebeb;
    background: #f2f2f4;
  }
  .filtrationShow-yes{
    width: 50%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #3f97ee;
    color: #fff;
  }
</style>
<style>
  .cgs-worksheet-cgsFormContent .van-search {
    background-color: transparent;
  }
</style>